// 企业微信认证工具

const API_BASE = import.meta.env.DEV ? '/api' : '/okr/api'

// 检查登录状态
export async function checkAuth(): Promise<boolean> {
  try {
    const token = localStorage.getItem('okr_token')
    if (!token) return false

    sessionStorage.removeItem('wxwork_auto_login_at')

    // 这里可以添加token验证逻辑
    // 简化处理：检查token是否存在
    return true
  } catch (error) {
    console.error('检查认证状态失败:', error)
    return false
  }
}

// 企业微信登录跳转
export function wxworkLogin() {
  window.location.href = `${API_BASE}/wxwork/auth`
}

// 处理回调
export async function handleCallback(code: string): Promise<any> {
  try {
    const response = await fetch(`${API_BASE}/wxwork/callback?code=${code}`)
    if (!response.ok) throw new Error('认证失败')
    
    const data = await response.json()
    if (data.success) {
      // 保存用户信息
      localStorage.setItem('okr_token', 'authenticated')
      localStorage.setItem('okr_userId', data.userId)
      localStorage.setItem('okr_userInfo', JSON.stringify(data.userInfo))
      return data
    } else {
      throw new Error(data.error || '认证失败')
    }
  } catch (error) {
    console.error('处理回调失败:', error)
    throw error
  }
}

// 登出
export function logout() {
  localStorage.removeItem('okr_token')
  localStorage.removeItem('okr_userId')
  localStorage.removeItem('okr_userInfo')
  window.location.href = '/okr/login'
}

// 获取当前用户信息
export function getCurrentUser() {
  if (typeof window === 'undefined') return { name: '企业微信用户', userId: '' }
  const raw = localStorage.getItem('okr_userInfo')
  const fallbackId = localStorage.getItem('okr_userId') || ''
  const fallback = { name: fallbackId || '企业微信用户', userId: fallbackId }
  if (!raw) return fallback
  try {
    const parsed = JSON.parse(raw)
    return {
      name: parsed.name || parsed.UserId || parsed.userId || fallback.name,
      userId: parsed.UserId || parsed.userId || fallback.userId
    }
  } catch {
    return fallback
  }
}
